import dashboard from './dashboard';
import pages from './pages';
import utilities from './utilities';
import other from './other';
import execution from './execution';

// ==============================|| MENU ITEMS ||============================== //

const menuItems = {
    items: [dashboard, execution]
};

export default menuItems;
